import React from "react";
import { useFormikContext } from "formik";
import BasicInfoStep from '../../../../Forms/Steps/BasicInfoStep';
import { featureInfoFields, featureBlockFields, getBlockImgOptions } from '../Helpers/CopyAndFunctions';

const FeatureFields = () => {
  const { values } = useFormikContext();
  if (!values?.settings) return null;
  const imageBlock1Options = getBlockImgOptions('1', values.settings.featureBlockImage1);
  const imageBlock2Options = getBlockImgOptions('2', values.settings.featureBlockImage2);
  const imageBlock3Options = getBlockImgOptions('3', values.settings.featureBlockImage3);

  return (
      <>
        <div className="mb20"><BasicInfoStep fields={featureInfoFields} /><hr /></div>
        <div className="mb20">
          <BasicInfoStep
            fields={featureBlockFields(1)}
            imgUploadOptions={imageBlock1Options}
            showImgUploader
          />
          <hr />
        </div>
        
        <div className="mb20">
          <BasicInfoStep
            fields={featureBlockFields(2)}
            imgUploadOptions={imageBlock2Options}
            showImgUploader
          />
          <hr />
        </div>
        
        <div className="mb20">
          <BasicInfoStep
            fields={featureBlockFields(3)}
            imgUploadOptions={imageBlock3Options}
            showImgUploader
          />
          <hr />
        </div>
        
      </>
    );
};

export default FeatureFields;
